import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

const VerifyEmailPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setStatus('error');
      setMessage('Токен верификации не найден в ссылке');
      return;
    }

    fetch(`/api/auth/verify-email?token=${token}`)
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setStatus('success');
          setMessage('Ваш email успешно подтверждён!');
        } else {
          setStatus('error');
          setMessage(data.message || 'Ошибка верификации');
        }
      })
      .catch(() => {
        setStatus('error');
        setMessage('Ошибка соединения с сервером');
      });
  }, [searchParams]);

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(180deg, #0a0a1a 0%, #1a1a2e 100%)',
      padding: '20px',
    }}>
      <div style={{
        background: 'rgba(13, 20, 40, 0.85)',
        backdropFilter: 'blur(20px)',
        border: '1px solid rgba(212, 175, 55, 0.12)',
        borderRadius: '24px',
        padding: '60px 40px',
        maxWidth: '500px',
        width: '100%',
        textAlign: 'center',
        boxShadow: '0 8px 40px rgba(212, 175, 55, 0.08), inset 0 0 40px rgba(13, 20, 40, 0.5)',
        position: 'relative',
      }}>
        <div style={{ position: 'absolute', top: 0, left: '10%', right: '10%', height: '2px', background: 'linear-gradient(90deg, transparent, #d4af37, transparent)' }} />
        {status === 'loading' && (
          <>
            <div style={{
              fontSize: '64px',
              marginBottom: '24px',
              animation: 'pulse 2s ease-in-out infinite',
            }}>
              ⏳
            </div>
            <h2 style={{
              color: '#d4af37',
              fontSize: '28px',
              fontFamily: 'var(--font-display)',
              fontStyle: 'italic',
              marginBottom: '16px',
            }}>
              Подтверждаем ваш email...
            </h2>
            <p style={{ color: '#888', fontSize: '16px' }}>
              Пожалуйста, подождите
            </p>
          </>
        )}

        {status === 'success' && (
          <>
            <div style={{
              fontSize: '80px',
              marginBottom: '24px',
              animation: 'fadeIn 0.5s ease',
            }}>
              ✨
            </div>
            <h2 style={{
              color: '#d4af37',
              fontSize: '32px',
              fontFamily: 'var(--font-display)',
              fontStyle: 'italic',
              marginBottom: '16px',
              background: 'linear-gradient(135deg, #F4E4A6 0%, #D4AF37 40%, #B8942B 70%, #F4E4A6 100%)',
              backgroundSize: '200% auto',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
            }}>
              Добро пожаловать в Astranum!
            </h2>
            <p style={{
              color: '#e0e0e0',
              fontSize: '18px',
              lineHeight: '1.6',
              marginBottom: '12px',
            }}>
              {message}
            </p>
            <p style={{
              color: '#888',
              fontSize: '15px',
              lineHeight: '1.6',
              marginBottom: '32px',
            }}>
              Благодарим вас за регистрацию! Сейчас мы готовим вашу персональную натальную карту и нумерологический профиль. Это займёт несколько секунд.
            </p>

            <button
              onClick={() => navigate('/dashboard')}
              style={{
                background: 'linear-gradient(135deg, #d4af37 0%, #f4d03f 100%)',
                border: 'none',
                padding: '16px 48px',
                borderRadius: '30px',
                color: '#0a0a1a',
                fontSize: '16px',
                fontWeight: '600',
                cursor: 'pointer',
                boxShadow: '0 4px 20px rgba(212, 175, 55, 0.4)',
                transition: 'all 0.3s',
                fontFamily: 'var(--font-sans)',
                letterSpacing: '0.5px',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-3px)';
                e.currentTarget.style.boxShadow = '0 8px 30px rgba(212, 175, 55, 0.6)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 20px rgba(212, 175, 55, 0.4)';
              }}
            >
              Узнать свою натальную карту ✦
            </button>

            <div style={{
              marginTop: '32px',
              padding: '20px',
              background: 'rgba(212, 175, 55, 0.05)',
              border: '1px solid rgba(212, 175, 55, 0.2)',
              borderRadius: '12px',
            }}>
              <p style={{
                color: '#d4af37',
                fontSize: '14px',
                marginBottom: '8px',
                fontFamily: 'var(--font-sans)',
              }}>
                ✦ Что вас ждёт:
              </p>
              <ul style={{
                color: '#b0b0b0',
                fontSize: '13px',
                lineHeight: '1.8',
                textAlign: 'left',
                paddingLeft: '20px',
              }}>
                <li>Персональная натальная карта с расшифровкой</li>
                <li>Нумерологический профиль</li>
                <li>Описание вашей личности</li>
                <li>Рекомендации и прогнозы</li>
              </ul>
            </div>
          </>
        )}

        {status === 'error' && (
          <>
            <div style={{
              fontSize: '64px',
              marginBottom: '24px',
            }}>
              ⚠️
            </div>
            <h2 style={{
              color: '#ff6b6b',
              fontSize: '28px',
              fontFamily: 'var(--font-display)',
              fontStyle: 'italic',
              marginBottom: '16px',
            }}>
              Ошибка верификации
            </h2>
            <p style={{
              color: '#e0e0e0',
              fontSize: '16px',
              lineHeight: '1.6',
              marginBottom: '32px',
            }}>
              {message}
            </p>
            <button
              onClick={() => navigate('/')}
              style={{
                background: 'linear-gradient(135deg, #d4af37 0%, #f4d03f 100%)',
                border: 'none',
                padding: '14px 40px',
                borderRadius: '25px',
                color: '#0a0a1a',
                fontSize: '16px',
                fontWeight: 'bold',
                cursor: 'pointer',
              }}
            >
              На главную
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default VerifyEmailPage;
